import React, {useEffect, useState} from "react";
import {useAtom} from "jotai";
import {modalController} from "../../store";
import {light} from "../../assets/theme";
import {ModalBody, ModalFooter, ModalHeader} from "../modal/Modal";
import {CancelButton} from "../../assets/GlobalStyles";
import {Off, On, PreviewSubmit, SwitchBox} from "../table/styles";

export default function SwitchComponent(props) {
  const {value, cellProps, type, eventClick} = props
  const [select, setSelect] = useState(value)
  const [, setModal] = useAtom(modalController)
  const background = !select ? {background: light.color.lightGray}
      : {background: light.color.mainColor};
  const position = select ? {
    left: ' calc(100% - 4px)',
    transform: 'translateX(-100%)'
  } : null
  useEffect(() => {
    return () => {
      setModal({
        isShow: false
      })
    }
  }, [])

  useEffect(() => {
    if (type === 'publish') {
      setSelect(cellProps.data.publishYn === 'Y')
    } else {
      setSelect(cellProps.data.interlockYn === 'Y')
    }
  }, [value]);

  const handleClick = (confirm) => {
    if (confirm) {
      eventClick();
      setSelect(!select)
      if (type === 'publish') {
        cellProps.data.publishYn = cellProps.data.publishYn === 'Y' ? 'N' : 'Y';
      } else {
        cellProps.data.interlockYn = cellProps.data.interlockYn === 'Y' ? 'N'
            : 'Y';
      }
    } else {
      setSelect(select)
    }
    setModal({isShow: false});
  }
  const showModal = () => {
    const btnSmall = {width: 100, height: 42}
    setModal({
      isShow: true,
      width: 400,
      modalComponent: () => {
        return (
            <div>
              {type !== 'publish' && <ModalHeader title={'연동 상태 변경'}
                                                  closeButton/>}
              <ModalBody>
                <p style={{fontSize: 16, paddingTop: 10}}>
                  {type !== 'publish' ? (!select ? '연동을 사용 하시겠습니까?'
                      : '연동을 중지 하시겠습니까?') : '게재 상태를 변경하시겠습니까?'}
                </p>
              </ModalBody>
              <ModalFooter style={{borderTop: 0, paddingTop: 5}}>
                <CancelButton style={btnSmall} onClick={() => handleClick(
                    false)}>취소</CancelButton>
                <PreviewSubmit style={btnSmall} onClick={() => handleClick(
                    true)}>확인</PreviewSubmit>
              </ModalFooter>
            </div>
        )
      }
    })
  }

  return (
      <SwitchBox
          style={background}
          onClick={() => showModal()}
      >
        <label style={position}/>
        {select ? <On>ON</On> : <Off>OFF</Off>}
      </SwitchBox>
  )
}